import logoPardini from "../shared/layout/logo/img/logo_pardini.svg";
import logoMyPardini from "../shared/layout/logo/img/logo_mypardini.svg";
import { EMPRESAS } from "../shared/utils/Constantes";

export const obterLogoEmpresa = (empresa, ehMyPardini) => {
  if (ehMyPardini) {
    return logoMyPardini;
  }

  return !empresa.imagemSvgLogoHorizontal ? logoPardini : `data:image/svg+xml;base64,${empresa.imagemSvgLogoHorizontal}`
};
